const ocean = {
    50: '#e1f2fe',
    100: '#b5defd',
    200: '#83c9fc',
    300: '#51b3fb',
    400: '#2ca2fa',
    500: '#0792f9',
    600: '#068af8',
    700: '#057ff7',
    800: '#0475f6',
    900: '#0263f5',
    A100: '#ffffff',
    A200: '#e8f0ff',
    A400: '#b5ceff',
    A700: '#9cbeff',
    'contrastDefaultColor': 'light',
};

export default ocean;
